import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPaymentType, deletePaymentType } from '../actions/PaymentTypeActions';
import { Pane, Heading, Button } from 'evergreen-ui';

import DeleteDialog from '../../common/DeleteDialog/DeleteDialog';
import { Link } from 'react-router-dom';
import PaymentTypeInfoBlock from '../components/PaymentTypeInfoBlock';

class ViewPaymentType extends Component {
    constructor(props) {
        super(props);

        this.id = this.props.params.id;
    }
    
    componentDidMount() {
        this.props.dispatch(getPaymentType(this.id))
    }

    handleDelete = () => {
        this.props.dispatch(deletePaymentType(this.id));
    }

    render() {
            
        return (
            <Pane padding={16} paddingTop={0}>
                <Pane display="flex">
                    <Pane>
                        <Link to="/payment-types">
                            <Button iconBefore="arrow-left">
                                Inapoi la lista modalitati de plata
                            </Button>
                        </Link>
                    </Pane>
                    
                    <Pane marginLeft={16} alignSelf="flex-end">
                        <DeleteDialog
                            onDelete={this.handleDelete}
                            buttonLabel="Sterge modalitatea de plata"
                            title="Confirmare stergere modalitate de plata"
                            confirmLabel="Sterg definitiv modalitatea de plata"
                            message="Esti sigur ca vrei sa stergi modalitatea de plata?"/>
                    </Pane>
                </Pane>

                <Pane flex={1} background="tint1" elevation={1} padding={16} marginTop={16}>
                    <Heading size={600}>
                        Modalitate de plata - <strong>{this.props.paymentType.name}</strong>
                    </Heading>
                </Pane>
                
                <Pane display="flex" justifyContent="space-between" flex={1} marginTop={16}>
                    <PaymentTypeInfoBlock paymentType={this.props.paymentType}/>
                </Pane>
            </Pane>
        )
    }
}

function mapStateToProps(state) {
    return {
        paymentType: state.paymentTypes.current
    }
}

export default connect(mapStateToProps)(ViewPaymentType);